import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { UserMultiSelectField } from "../../../shared/ui/UserMultiSelectField";
import { tenantService } from "../shared/api/tenantService";
import { TenantFormValues } from "../shared/types";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: TenantFormValues) => {
		const errors: { [K in keyof TenantFormValues]?: any } = {};

		if (!values.name) {
			errors.name = t("Required field");
		}
		if (!values.users.length) {
			errors.users = t("Required field");
		}

		return errors;
	};
};

const TenantFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="name" label={t("Name")} />
			<UserMultiSelectField name="users" label={t("Users")} />
		</FormDrawerContent>
	);
};

export const TenantCreateDrawer: FC<CreateDrawerFormProps<TenantFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	const initialValues: TenantFormValues = {
		name: "",
		users: [],
	};

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Add tenant")}
			validate={validate}
			renderForm={(formProps) => <TenantFormDrawerContent {...formProps} {...props} />}
		/>
	);
};

export const TenantUpdateDrawer: FC<UpdateDrawerFormProps<TenantFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Edit tenant")}
			queryFn={() => tenantService.show(props.id).then((x) => x.data.data)}
			queryKey={tenantService.showKey(props.id)}
			validate={validate}
			renderSuccess={(formProps) => <TenantFormDrawerContent {...props} {...formProps} />}
		/>
	);
};
